export default "__VITE_ASSET__B9qwus1a__"